<template>
	<dialog-component custom-class="paywall-wrap" @close="onClose">
		<p class="paywall-title">{{ title }}</p>
		<p class="paywall-description">{{ plansStore.paywallDescription }}</p>
		<div class="paywall-btn-group">
			<base-button :text="plansStore.cta" @click="getPro" />
		</div>
	</dialog-component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DialogComponent from '@/components/dialogs/DialogComponent.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { PRO_LIMIT_TITLES } from '@/constants/pro'
import { usePlansStore } from '@/stores/plans'
import { usePaymentFlow } from '@/composables/usePaymentFlow'
import { proAvailabilityTitle } from '@/utils/proTitle'
import type { PaywallVariant } from '@/stores/paywall'

const props = withDefaults(defineProps<{ variant?: PaywallVariant; topicName?: string }>(), {
	variant: 'topic',
	topicName: ''
})

const emit = defineEmits<{ close: [] }>()

const plansStore = usePlansStore()
const { startCheckout } = usePaymentFlow()

const title = computed(() =>
	props.variant === 'topic' ? proAvailabilityTitle(props.topicName) : PRO_LIMIT_TITLES[props.variant]
)

function onClose() {
	emit('close')
}

function getPro() {
	startCheckout('paywall')
	onClose()
}
</script>

<style lang="scss" scoped>
.paywall {
	&-title {
		font: var(--font-title);
		color: var(--text-primary);
		text-align: center;
		margin-bottom: 12px;
	}
	&-description {
		font: var(--font-body-small);
		color: var(--text-secondary);
		text-align: center;
		margin-bottom: 24px;
	}
	&-btn-group {
		width: 100%;
		// перебиваем padding: 15px 20px из .btn в BaseButton
		.btn {
			width: 100%;
			padding: 14px 12px;
			min-height: 52px;
		}
	}
}
</style>
